import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "rounded-card bg-white border border-stone p-8 md:p-12" }
const _hoisted_2 = { class: "max-w-2xl mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block rounded-badge bg-secondary text-primary text-xs font-medium tracking-label uppercase px-3 py-1" }, " Birlikte Çalışalım ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-3xl md:text-4xl font-medium text-primary tracking-display leading-[0.95]" }, " Bloqin yolculuğunda yer al. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-graphite text-base md:text-lg leading-relaxed" }, " Advisory board üyeliği, stratejik ortaklık, gayrimenkul sponsorluğu veya farklı bir rolle Bloqin ekosistemine katkı sağlamak istiyorsan formu doldur. Kısa süre içinde dönüş yaparız. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-name",
  class: "block text-primary text-sm font-medium mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Ad Soyad "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-coral" }, "*")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-email",
  class: "block text-primary text-sm font-medium mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" E-posta "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-coral" }, "*")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-phone",
  class: "block text-primary text-sm font-medium mb-2"
}, " Telefon ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-org",
  class: "block text-primary text-sm font-medium mb-2"
}, " Şirket / Kuruluş ", -1)
const _hoisted_10 = { class: "md:col-span-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-role",
  class: "block text-primary text-sm font-medium mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" İlgilendiğin rol "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-coral" }, "*")
], -1)
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled>Bir seçenek seç</option><option value=\"advisory_board\">Advisory Board Üyeliği</option><option value=\"strategic_partner\">Stratejik Ortaklık</option><option value=\"real_estate_sponsor\">Gayrimenkul Sponsorluğu</option><option value=\"technology_partner\">Teknoloji Ortaklığı</option><option value=\"legal_regulatory\">Hukuk &amp; Regülasyon Danışmanlığı</option><option value=\"institutional_investor\">Kurumsal Yatırımcı</option><option value=\"other\">Diğer</option>", 8)
const _hoisted_20 = [
  _hoisted_12
]
const _hoisted_21 = { class: "md:col-span-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "app-message",
  class: "block text-primary text-sm font-medium mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Mesaj "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-coral" }, "*")
], -1)
const _hoisted_23 = { class: "md:col-span-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-2" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-graphite text-xs leading-relaxed" }, " Gönderdiğin bilgiler yalnızca değerlendirme amacıyla kullanılır. KVKK kapsamında verilerin korunmaktadır. ", -1)
const _hoisted_26 = {
  key: 0,
  class: "md:col-span-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: "mt-10 grid grid-cols-1 md:grid-cols-2 gap-5"
      }, [
        _createElementVNode("div", null, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            id: "app-name",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.full_name) = $event)),
            required: "",
            placeholder: "Adın ve soyadın",
            class: "w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary"
          }, null, 512), [
            [_vModelText, _ctx.form.full_name]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            id: "app-email",
            type: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
            required: "",
            placeholder: "seninadin@email.com",
            class: "w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary"
          }, null, 512), [
            [_vModelText, _ctx.form.email]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            id: "app-phone",
            type: "tel",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event)),
            placeholder: "+90 555 555 55 55",
            class: "w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary"
          }, null, 512), [
            [_vModelText, _ctx.form.phone]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            id: "app-org",
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.organization) = $event)),
            placeholder: "Bağlı olduğun şirket veya kuruluş",
            class: "w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary"
          }, null, 512), [
            [_vModelText, _ctx.form.organization]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("select", {
            id: "app-role",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.role_interest) = $event)),
            required: "",
            class: "w-full px-4 py-3 rounded-btn bg-white text-primary border border-stone focus:outline-none focus:border-secondary appearance-none"
          }, _hoisted_20, 512), [
            [_vModelSelect, _ctx.form.role_interest]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("textarea", {
            id: "app-message",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.message) = $event)),
            required: "",
            rows: "5",
            placeholder: "Kendinden, deneyiminden ve Bloqin'e nasıl katkı sağlayabileceğinden bahset.",
            class: "w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary resize-none"
          }, null, 512), [
            [_vModelText, _ctx.form.message]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            type: "submit",
            class: "inline-flex items-center justify-center px-6 py-4 rounded-btn border border-primary bg-secondary text-primary text-base font-medium hover:bg-primary hover:text-secondary transition-colors whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed",
            disabled: _ctx.loading
          }, _toDisplayString(_ctx.loading ? 'Gönderiliyor…' : 'Talebi Gönder →'), 9, _hoisted_24),
          _hoisted_25
        ]),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("p", {
                class: _normalizeClass([_ctx.success ? 'text-primary' : 'text-coral', "text-sm font-medium"])
              }, _toDisplayString(_ctx.message), 3)
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}